import { determineCurrentStep, determineNextStep } from './helpers';
import { nextQuestionUpdated, previousQuestionUpdated, stepUpdated } from './questionnaire.slice';
import { FieldType } from './typings';
export var updateNextQuestion = function () { return function (dispatch, getState) {
    var _a = getState(), _b = _a.questionnaire, currentQuestion = _b.currentQuestion, questions = _b.questions, userAnswers = _a.userAnswers;
    var answer = currentQuestion.answers[0];
    var fieldType = answer.fieldType, answerOptions = answer.answerOptions;
    /*
     * The TableList field type will not write to the userAnswers slice,
     * so we will need to get the next question ID from the answer options array
     */
    var nextQuestionId = (fieldType === FieldType.TableList
        ? answerOptions[0]
        : userAnswers.find(function (userAnswer) {
            return (userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.id.toUpperCase()) === (currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.id.toUpperCase());
        })).nextQuestionId;
    var nextStep = determineNextStep(nextQuestionId, currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.id);
    if (nextStep) {
        dispatch(stepUpdated(nextStep));
    }
    var nextQuestion = questions.find(function (question) { return question.id.toUpperCase() === nextQuestionId.toUpperCase(); });
    dispatch(nextQuestionUpdated(nextQuestion));
}; };
export var updatePreviousQuestion = function () { return function (dispatch, getState) {
    var _a = getState(), userAnswers = _a.userAnswers, _b = _a.questionnaire, previousQuestions = _b.previousQuestions, step = _b.step, transactionAccountCredits = _b.transactionAccountCredits;
    var previousQuestion = previousQuestions[previousQuestions.length - 1];
    var previousAnswer = userAnswers[userAnswers.length - 1];
    var currentStep = determineCurrentStep(step, previousQuestion, previousAnswer, transactionAccountCredits);
    if (currentStep) {
        dispatch(stepUpdated(currentStep));
    }
    dispatch(previousQuestionUpdated());
}; };
//# sourceMappingURL=thunks.js.map